export const publisherRestrictionPurposeIds = [3, 4]
